<template>
<div class="page page_xiaofei">
    <!-- 分页 -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
            <div class="list" v-for="item in cardList" :key="item.id">
                <div class="item">
                    <img :src="$publicData.defaultTouxiang" alt="" class="thumb">
                    <div class="item_r">
                        <div class="item_nr">
                            <div class="title slh_s">{{item.pay_order_num}}</div>
                            <div class="time">{{item.created_at}}</div>
                        </div>
						<!-- 1收入 0支出 -->
                        <div class="price"><span class="tag_cash">{{ item.type==1?'+':'-' }}¥</span>{{item.money}}</div>
                    </div>
                </div>
            </div>
        </van-list>
    </van-pull-refresh>
</div>
<!-- <div class="page_set page">
    <div class="record">
        <div class="col">支付订单编号</div>
        <div class="col">消费金额</div>
        <div class="col">消费时间</div>
    </div>
    <div class="record">
        <div class="col">60000000000000</div>
        <div class="col">60.00</div>
        <div class="col">20200505</div>
    </div>
</div> -->
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: "set-card",
    data() {
        return {
            publicPath: process.env.BASE_URL,
            isClient: false, //是否在iOSAndroid客户端内显示
            token: null,
            card_id: this.$route.query.card_id ,// 充值卡id
            cardList: [],
            finished: false,
            page: 1,
            size: 10,
            loading: false,
			refreshing: false,
			type: this.$route.query.type ? this.$route.query.type : 1 // 1 平台卡 2园区卡
        };
    },
    created: function () {

    },
    mounted: function () {
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            this.setClientInfo()
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                this.setClientInfo()
                responseCallback('refresh success')
            })
            //注册方法，右上角设置按钮点击事件
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                var memberParams = {
                    'data': {
                        'forceLogin': 1,
                    }
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {

                })
                responseCallback('success')
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
            this.getData()
        }
    },
    methods: {
        setClientInfo() {
            //修改导航栏样式
            var styleParams = {
                'data': {
                    'naviTitle': '使用记录',
                    // 'hiddenBack': true,
                    // 'rightStyle': 'setup'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', styleParams, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            console.log('sdjy://member/memberInfo')
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
        },
        onRefresh() {
            // 清空列表数据
            this.finished = false;

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.page = 1
            this.getData();
        },
        getData() {
            console.log('getData')
            if (this.token == null || this.token == undefined || this.token == '') {
                return
            }
            var params = {
                token: this.token,
                // card_id: this.card_id,
                page: this.page,
                size: this.size
			}
			if(this.type == 1){
				// 平台充值卡
				params.card_id = this.card_id
				this.$api.my.cardShow(params).then(res => {
					console.log('res')
					console.log(res)
					if (res.code == 200) {
						var list = res.result.list
						if (this.page == 1) {
							this.cardList = list
						} else {
							var old = this.cardList
							for (let i = 0; i < list.length; i++) {
								old.push(list[i])
							}
							this.cardList = old
						}
						if (list.length < this.size) {
							// 数据全部加载完
							this.finished = true
							this.refreshing = false
							return;
						}
					} else {
						this.finished = true
						this.$toast(res.message)
					}
					this.page++;
					this.refreshing = false
					this.loading = false;
				})
			}else if(this.type == 2){
				// 园区充值卡
				params.park_card_id = this.card_id
				this.$api.my.parkCardShow(params).then(res => {
					console.log('res')
					console.log(res)
					if (res.code == 200) {
						var list = res.result
						if (this.page == 1) {
							this.cardList = list
						} else {
							var old = this.cardList
							for (let i = 0; i < list.length; i++) {
								old.push(list[i])
							}
							this.cardList = old
						}
						if (list.length < this.size) {
							// 数据全部加载完
							this.finished = true
							this.refreshing = false
							return;
						}
					} else {
						this.finished = true
						this.$toast(res.message)
					}
					this.page++;
					this.refreshing = false
					this.loading = false;
				})
			}
            
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
